import React from 'react';
import { Link } from 'react-router';
import './AboutPage.css';

const steps = [
    {
        title: 'Choose your certification',
        desc: 'Select a group and topic from the dropdowns on the Study page. Your selection is remembered across sessions.',
    },
    {
        title: 'Answer in your own words first',
        desc: 'Type your answer into the free-text box before seeing the options. This forces active recall — the most effective study method.',
    },
    {
        title: 'Submit and compare',
        desc: 'Hit Submit. If your answer is 90% or more correct, the right multiple-choice option is highlighted for you automatically.',
    },
    {
        title: 'Select the correct answer',
        desc: 'If your free-text answer scored below 90%, select the correct option from the multiple-choice list and confirm.',
    },
    {
        title: 'Rate your confidence',
        desc: 'After a correct submission, rate how confident you are — Low, Medium, or High. This helps surface the questions you need most.',
    },
    {
        title: 'Read the explanations',
        desc: 'Every question includes an explanation of the correct answer and why each incorrect option is wrong. Don\'t skip these.',
    },
    {
        title: 'Explore Further Learning',
        desc: 'Below each question you\'ll find YouTube videos, a step-by-step lab guide, and links to official vendor documentation.',
    },
    {
        title: 'Move to the next question',
        desc: 'Hit Next to get a new question. Use Generate New Question if you want the AI to create a fresh one for your chosen topic.',
    },
];

const features = [
    { icon: '🤖', title: 'AI-generated questions', desc: 'Fresh questions on demand, tailored to your topic' },
    { icon: '🎥', title: 'YouTube integration', desc: 'Relevant videos sourced automatically per question' },
    { icon: '🧪', title: 'Lab guides', desc: 'Step-by-step hands-on practice guides' },
    { icon: '📅', title: 'Goal tracking', desc: 'Set an exam date and track days remaining' },
];

function AboutPage() {
    return (
        <div className="about-page">

            <div className="about-hero">
                <p className="about-hero-eyebrow">How it works</p>
                <h1 className="about-hero-headline">
                    Study smarter.<br />
                    Pass your <em>certification</em>.
                </h1>
                <p className="about-hero-sub">
                    CertDrill combines AI-generated practice questions, confidence tracking,
                    and curated learning resources — all in one focused study flow.
                </p>
                <Link to="/study" className="about-hero-cta">
                    Start studying →
                </Link>
            </div>

            <hr className="about-divider" />

            <div className="about-steps-section">
                <p className="about-steps-label">Step by step</p>
                <h2 className="about-steps-title">Your study session, explained</h2>

                <div className="about-steps-list">
                    {steps.map((step, i) => (
                        <div className="about-step" key={i}>
                            <div className="about-step-number">
                                {String(i + 1).padStart(2, '0')}
                            </div>
                            <div className="about-step-body">
                                <p className="about-step-title">{step.title}</p>
                                <p className="about-step-desc">{step.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="about-features">
                <div className="about-features-inner">
                    {features.map((f, i) => (
                        <div className="about-feature-pill" key={i}>
                            <span className="about-feature-icon">{f.icon}</span>
                            <span className="about-feature-text">
                                <strong>{f.title}</strong>
                                {f.desc}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
}

export default AboutPage;
